var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "tables-settings layout",
      class: {
        empty: _vm.isEmpty,
      },
    },
    [
      _c("div", { staticClass: "layout-title" }, [_vm._v("Настройки")]),
      _c(
        "div",
        { staticClass: "tables-settings__tabs" },
        [
          _c("c-tabs", {
            attrs: {
              items: [
                {
                  label: "Общие настройки",
                  value: "/index.php?r=total-settings%2Findex",
                  link: "/index.php?r=total-settings%2Findex",
                },
                {
                  label: "Настройки таблиц",
                  value: "tables-settings",
                  disabled: !_vm.userHavePermissionForTablesSettings,
                },
                {
                  label: "Автоматическое создание ведомостей",
                  value: "auto-creation-calc-sheets",
                  disabled: !_vm.userHavePermissionForAutoCreationCalcSheets,
                },
              ],
              "with-routing": "",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "tables-settings__content" }, [
        _vm.inited
          ? _c("div", { staticClass: "row tables-settings__actions" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col col-12 col-md-8 col-lg-6 tables-settings__search",
                },
                [
                  !_vm.isEmpty
                    ? _c("c-input", {
                        attrs: {
                          placeholder: "Поиск",
                          type: "text",
                          clearable: true,
                          icon: "search",
                        },
                        on: { enter: _vm.applyFilters },
                        model: {
                          value: _vm.query,
                          callback: function ($$v) {
                            _vm.query = $$v
                          },
                          expression: "query",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col col-12 col-md-4 col-lg-6 tables-settings__add",
                },
                [
                  _c("c-button", {
                    attrs: {
                      label: "Добавить настройку",
                      icon: {
                        icon: "plus",
                        color: "blue",
                      },
                    },
                    on: { click: _vm.addTableSettings },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "tables-settings__list" },
          [
            _c("tables-settings-table", {
              attrs: {
                inited: _vm.inited,
                items: _vm.items,
                empty: _vm.isEmpty,
                "sort-by": _vm.sortBy,
                loading: _vm.loading,
              },
              on: {
                nextPage: _vm.nextPage,
                sort: _vm.sort,
                remove: _vm.removeTableSettings,
              },
            }),
          ],
          1
        ),
      ]),
      _c("top-button", { attrs: { root: ".layout" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }